import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useListaCidadesService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { IListaCidades } from "../../../../../../../application/models";

export const RecorteListasCidadeEdit = () => {
  const { listasCidades } = useAppSelector((state) => state.listaCidades);
  const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao);

  const [selectedListasCidades, setSelectedListasCidades] = useState<IListaCidades[]>([]);

  const { setupListaCidades } = useListaCidadesService();
  const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService();

  // Effects
  useEffect(() => {
    const listasSelecionadasIds = editRecorteExtracaoForm.fields.Filtros?.listasCidades || [];

    if (listasSelecionadasIds.length > 0) {
      const listasCompletas = listasCidades.filter(lista =>
        listasSelecionadasIds.includes(lista.IdVelesGeoListaCidade)
      );
      setSelectedListasCidades(listasCompletas);
    } else {
      setSelectedListasCidades([]);
    }
  }, [editRecorteExtracaoForm.fields.Filtros?.listasCidades, listasCidades]);

  useEffect(() => {
    setupListaCidades();
  }, [setupListaCidades]);

  // Filter options to show only non-selected lists
  const filteredListasCidades = listasCidades.filter((lista) =>
    !selectedListasCidades.some(selected => selected.IdVelesGeoListaCidade === lista.IdVelesGeoListaCidade)
  );


  const handleListasCidadesSelectionChange = (value: IListaCidades[]) => {
    setSelectedListasCidades(value);

    if (value.length > 0) {
      syncFilterWithForm({
        filtro: "listasCidades",
        value: value.map((lista) => lista.IdVelesGeoListaCidade),
        formType: 'edit'
      });
    } else {
      removeFilterFromForm({
        filtro: "listasCidades",
        formType: 'edit'
      });
    }
  };

  return (
    <>
      <Grid item xs={11} my={2}>
        <Autocomplete
          multiple
          id="listas-cidades-autocomplete"
          options={filteredListasCidades}
          getOptionLabel={(option) => option.Nome?.toUpperCase() || ""}
          isOptionEqualToValue={(option, value) =>
            option.IdVelesGeoListaCidade === value.IdVelesGeoListaCidade
          }
          value={selectedListasCidades}
          onChange={(_, value) => {
            handleListasCidadesSelectionChange(value);
          }}
          noOptionsText="Nenhuma lista encontrada"
          filterSelectedOptions={true}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Listas de Cidades"
            />
          )}
          sx={{ px: 2 }}
        />
      </Grid>
    </>
  );
};